/**
 * Erros da app web para a API (POST /public/client-errors), sem dados pessoais
 * (`cleanReport`). No máximo alguns por página e sem repetir a mesma mensagem.
 */
import { cleanReport } from '@nolens/domain';
import { ApiError } from './api';
import { config } from './config';

const VERSION = (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev';
const MAX_PER_PAGE = 10;
const sent = new Set<string>();

export function reportError(err: unknown): void {
  try {
    if (!config.apiUrl || sent.size >= MAX_PER_PAGE) return;
    const e = err instanceof Error ? err : new Error(String(err));
    // Falhas de rede e erros esperados da API não são defeitos da app.
    if (e instanceof ApiError || e.name === 'AbortError') return;
    const report = cleanReport({
      source: 'web',
      version: VERSION,
      where: window.location.pathname,
      message: `${e.name}: ${e.message}`,
      ...(e.stack ? { stack: e.stack } : {}),
    });
    if (sent.has(report.message)) return;
    sent.add(report.message);
    void fetch(config.apiUrl + '/public/client-errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(report),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // o registo de erros nunca pode partir a app
  }
}

/** Erros não apanhados (scripts e promessas). */
export function installErrorReporting(): void {
  window.addEventListener('error', (e) => reportError(e.error ?? e.message));
  window.addEventListener('unhandledrejection', (e) => reportError(e.reason));
}
